export const fetchPartners = async ({ partners, setPartners, setError }) => {
  try {
    const response = await partners.getAll();
    setPartners(response.data);
  } catch (error) {
    console.error("Error fetching partners:", error);
    setError("Failed to load partners data");
  }
};
